export const environment = {
    production: false,
    hmr: false,
    qa: false,
    tcmURL: 'https://gonzalescountytxapp.meetingmanager.tylerapp.com/tylermmcalendar39635prod/'
};
